const facetFilters = () => {
  let filterOverlay = document.getElementById('v-filters');

  // const body = document.querySelector('body');
  // [...document.querySelectorAll('.v-filters__mobile')].forEach(function(filter) {
  //   filter.addEventListener('click', function() {
  //     filterOverlay.classList.add('open');
  //     body.classList.add('filters-open');
  //   });
  // });
  // [...document.querySelectorAll('.v-filters__close')].forEach(function(filter) {
  //   filter.addEventListener('click', function() {
  //     filterOverlay.classList.remove('open');
  //     body.classList.remove('filters-open');
  //   });
  // });

  const filtersWrap = document.querySelector('.v-portfolio__filters-wrap');

  if (filtersWrap) {
    filtersWrap.addEventListener('click', e => {
      if (e.target.nodeName !== 'BUTTON') return;
      filterOverlay.classList.remove('open');
    });


    const wrap = document.querySelector('.v-portfolio__wrap');
    document.addEventListener('facetwp-refresh', () => {
      wrap.classList.add('loading');
    });

    document.addEventListener('facetwp-loaded', () => {
      wrap.classList.remove('loading');
    });
  }
};
export default facetFilters;
